import React from 'react';
import SwatchAndColor from "../../../views/color/SwatchAndColor.js";
import OpenInJohnDeereButton from "../../../views/color/OpenInJohnDeereButton.js";
export default {
  install: molten => {
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.swatchAndColor',
      renderer: (value, valueStyle, object, _context) => {
        return /*#__PURE__*/React.createElement(SwatchAndColor, {
          value: Array.isArray(value) ? value[0] : null,
          object,
          style: valueStyle
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.openInJohnDeereButton',
      renderer: (value, valueStyle, object, _context) => {
        return /*#__PURE__*/React.createElement(OpenInJohnDeereButton, {
          value: Array.isArray(value) ? value[0] : null,
          object,
          style: valueStyle
        });
      }
    });
  }
};